import React from 'react';
import { useDispatch } from 'react-redux';
import { ContextualMenu, forceCloseContextualMenu } from '../../../shared/contextualMenu/content';
import { resendCNInvitation } from 'actions/waitingArea';
import { showCancelCNInvtiationModal, showExtendCNInvtiationModal } from 'actions/modal';
import { displayGlobalMessage } from 'actions/globalMessage';

export default function ConsultNowContextMenu(props) {
  const dispatch = useDispatch();
  const cancelConsultNowInvitation = (waitingAreaId) => {
    dispatch(showCancelCNInvtiationModal(true));
  };

  const resendConsultNowInvitation = (authTicketId) => {
    let cb = (result) => {
      if (result) {
        dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.SendConsultNowInvitation.InvitationSent,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      }
    };
    dispatch(resendCNInvitation(authTicketId, cb));
    contextualMenuCleanup();
  };

  const extendConsultNowInvitation = (waitingAreaId) => {
    dispatch(showExtendCNInvtiationModal(true));
  };

  const contextualMenuCleanup = () => {
    setTimeout(() => {
      forceCloseContextualMenu('.consult-now-container');
    }, 100);
  };

  let contextMenuPermissions = {
    openCall: props.waitingArea.permissions.indexOf('ANSWER_CALL') > -1,
    resendInvite:
      props.waitingArea.permissions.indexOf('ANSWER_CALL') > -1 ||
      props.waitingArea.permissions.indexOf('MANAGE_ACCESS') > -1 ||
      props.waitingArea.permissions.indexOf('EDIT') > -1,
    extendTime:
      props.waitingArea.permissions.indexOf('ANSWER_CALL') > -1 ||
      props.waitingArea.permissions.indexOf('MANAGE_ACCESS') > -1 ||
      props.waitingArea.permissions.indexOf('EDIT') > -1,
    cancelInvite: props.waitingArea.permissions.indexOf('ANSWER_CALL') > -1,
    isServiceAdmin: props.waitingArea.permissions.indexOf('EDIT') > -1,
    isServiceCordinator: props.waitingArea.permissions.indexOf('VIEW') > -1,
  };

  return (
    <ContextualMenu
      id={props.index}
      options={[
        {
          title: <div> {APP.LANGUAGE.ViewOneWaitingArea.OpenCall} </div>,
          show: contextMenuPermissions.openCall,
          customAction: false,
          action: () => {
            contextualMenuCleanup();
            let features = [
              'height=' + (window.screen.height - 100),
              'width=' + (window.screen.width - 20),
              'fullscreen=yes',
            ].join(',');
            // TODO: MVP+ get Another flag for enabling provider join Consult Now call
            // !props.providerIsInCallWithSomeUser
            window.open(`/ce/?consultNowAuth=${props.callerData.authTicketId}`, 'Provider Call Screen', features);
            // : '';
          },
          // TODO-HH - When user has opend the fake callscreen window, this "Open Call" tab needs to be disabled
          // fieldClass: props.providerIsInCallWithSomeUser ? 'disable-msg' : ''
        },
        {
          title: <div> {APP.LANGUAGE.ViewOneWaitingArea.OpenCall} </div>,
          customAction: false,
          show:
            !contextMenuPermissions.openCall &&
            !contextMenuPermissions.isServiceAdmin &&
            !contextMenuPermissions.openCall &&
            !contextMenuPermissions.isServiceCordinator,
          fieldClass: 'disable-msg',
        },
        {
          title: APP.LANGUAGE.ViewOneWaitingArea.OpenCall + ' ' + APP.LANGUAGE.ViewOneWaitingArea.cannotJoinAction,
          customAction: false,
          show:
            (!contextMenuPermissions.cancelInvite && contextMenuPermissions.isServiceAdmin) ||
            (!contextMenuPermissions.cancelInvite && contextMenuPermissions.isServiceCordinator),
          fieldClass: 'disable-msg',
        },
        {
          title: APP.LANGUAGE.ViewOneWaitingArea.ResendInvitation,
          // only visible for Service Provider
          show: contextMenuPermissions.resendInvite,
          action: () => resendConsultNowInvitation(props.callerData.authTicketId),
        },
        {
          title: APP.LANGUAGE.ViewOneWaitingArea.ResendInvitation,
          customAction: false,
          show: !contextMenuPermissions.resendInvite,
          fieldClass: 'disable-msg',
        },
        {
          title: <div> {APP.LANGUAGE.ViewOneWaitingArea.ExtendTime} </div>,
          // only visible for Service Provider
          show: contextMenuPermissions.extendTime,
          action: () => extendConsultNowInvitation(props.callerData.authTicketId),
        },
        {
          title: APP.LANGUAGE.ViewOneWaitingArea.ExtendTime,
          customAction: false,
          show: !contextMenuPermissions.extendTime,
          fieldClass: 'disable-msg',
        },
        {
          //Notify Participants
          title: <div> {APP.LANGUAGE.ViewOneWaitingArea.CancelInvitation} </div>, //keep in div if you dont want to close the context menu
          // only visible for Service Provider
          show: contextMenuPermissions.cancelInvite,
          action: () => cancelConsultNowInvitation(props.waitingArea.id),
        },
        {
          title: APP.LANGUAGE.ViewOneWaitingArea.CancelInvitation,
          customAction: false,
          show: !contextMenuPermissions.cancelInvite,
          fieldClass: 'disable-msg',
        },
      ]}
    />
  );
}
